import { useState } from 'react';
import useSmartNavigate from 'hooks/useSmartNavigate';
import { removeCustomer } from 'helpers/customer';
import { useLocation } from 'react-router-dom';
import useBreakpoint from 'hooks/useBreakpoint';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';

const AccountMenu = () => {
	const { t } = useTranslation();
	const accountItems = [
		{
			label: t('accountMenu.profile'),
			key: '/account',
			icon: 'icon-profile',
			iconActive: 'icon-profile-active',
		},
		{
			label: t('accountMenu.security'),
			key: '/account/password',
			icon: 'icon-lock-account',
			iconActive: 'icon-lock-account-active',
		},
		{
			label: t('accountMenu.orderHistory'),
			key: '/account/history',
			icon: 'icon-clock-account',
			iconActive: 'icon-clock-account-active',
		},
		{
			label: t('accountMenu.favorites'),
			key: '/account/wishlist',
			icon: 'icon-heart-account',
			iconActive: 'icon-heart-account-active',
		},
	];
	const { navigate } = useSmartNavigate();
	const location = useLocation();
	const { isMobile, isTablet } = useBreakpoint();
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const isMobileView = isMobile || isTablet;

	const handleMenuClick = key => {
		if (isMobileView) {
			setIsDropdownOpen(false);
		}
		navigate(key);
	};

	const handleLogout = () => {
		removeCustomer();
		window.location = '/';
	};

	const isActive = key => {
		if (key === '/account') {
			return location.pathname === '/account';
		}
		return location.pathname.startsWith(key);
	};

	// Найти активный пункт меню
	const activeItem =
		accountItems.find(item => isActive(item.key)) || accountItems[0];

	// Мобильная версия - дропдаун (без кнопки выхода, она добавляется отдельно)
	if (isMobileView) {
		return (
			<div className='account-menu account-menu-mobile'>
				{/* Выбранный раздел - кнопка дропдауна */}
				<button
					type='button'
					className={`account-menu-dropdown-trigger ${
						isDropdownOpen ? 'open' : ''
					}`}
					onClick={() => setIsDropdownOpen(!isDropdownOpen)}
				>
					<Icon name={activeItem.iconActive} className='account-menu-icon' />
					<span className='account-menu-label'>{activeItem.label}</span>
					<Icon
						name='icon-chevron-down'
						className={`account-menu-dropdown-arrow ${
							isDropdownOpen ? 'open' : ''
						}`}
					/>
				</button>

				{/* Выпадающий список */}
				{isDropdownOpen && (
					<div className='account-menu-dropdown'>
						{accountItems.map(item => (
							<button
								key={item.key}
								type='button'
								className={`account-menu-item ${
									isActive(item.key) ? 'account-menu-item-active' : ''
								}`}
								onClick={() => handleMenuClick(item.key)}
							>
								<Icon
									name={isActive(item.key) ? item.iconActive : item.icon}
									className='account-menu-icon'
								/>
								<span className='account-menu-label'>{item.label}</span>
							</button>
						))}
					</div>
				)}
			</div>
		);
	}

	// Десктопная версия
	return (
		<div className='account-menu'>
			<div className='account-menu-items'>
				{accountItems.map(item => (
					<button
						key={item.key}
						type='button'
						className={`account-menu-item ${
							isActive(item.key) ? 'account-menu-item-active' : ''
						}`}
						onClick={() => handleMenuClick(item.key)}
					>
						<Icon
							name={isActive(item.key) ? item.iconActive : item.icon}
							className='account-menu-icon'
						/>
						<span className='account-menu-label'>{item.label}</span>
					</button>
				))}
			</div>
			<button
				type='button'
				className='account-menu-logout'
				onClick={handleLogout}
			>
			{t('accountMenu.logout')}
		</button>
		</div>
	);
};

export default AccountMenu;
